import { getYear } from 'date-fns';

import { DatePickerDate } from '../types';

export default function convertYearRangeToArray({
  min,
  max,
  selectedDates = [],
}: {
  min: number;
  max: number;
  selectedDates?: (DatePickerDate | null)[] | null;
}) {
  const allYearsAscending = (selectedDates || [])
    .filter((x): x is DatePickerDate => x !== null)
    .map(getYear)
    .concat([min, max])
    .sort((a, b) => a - b);

  const minYear = allYearsAscending[0];
  const maxYear = allYearsAscending[allYearsAscending.length - 1];

  return Array.from({ length: maxYear - minYear + 1 }, (_, i) => ({
    key: i + minYear,
    label: i + minYear,
  }));
}
